import React from 'react'
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';


import { addToCart } from '../features/counter/counterSlice'
import { useDispatch } from 'react-redux';

function ProductDet() {

  const { id } = useParams();
  const navigate = useNavigate()
  const [products, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()



  const handleaddToCart = (products) => {
    dispatch(addToCart(products))
    navigate('/cart')
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      const response = await axios.get(`https://fakestoreapi.com/products/${id}`)

      setProduct(response.data)
      setLoading(false)

    }
    fetchData()
  }, [id]);


  const Loading = () => {
    return (
      <>
        Loading....
      </>
    )
  }
  const ShowProduct = () => {
    return (
      <>
        <div className="row mx-auto">
          <div className="col-md-4 m-auto " key={products.id}>
            <img src={products.image} alt={products.title} className='productDetImg' />
          </div>
          <div className="col-md-6 ">

            <h4 className='text-uppercase text-black-50 my-3'> {products.category}</h4>
            <h1 className='display-5 fs-3 fw-800'>{products.title}</h1>
            <p className='lead fw-bolder'> Rating {products.rating && products.rating.rate}
              <i className="fa-sharp fa-solid fa-star"></i>
            </p>
            <h3 className='display-6 fw-bold my-4'> $ {products.price}</h3>
            <p className="lead fs-6">{products.description}</p>
            <button className='btn btn-outline-dark ms-2 px-4' onClick={() => handleaddToCart(products)}> Add To Cart</button>
            <a href={products.linkurl} className='btn btn-dark ms-2 px-4'> Buy Now</a>
          </div>
        </div>
      </>
    )
  }
  return (
    <div>
      <div className="container py-5">
        <div className="row py-5">
          {loading ? <Loading /> : <ShowProduct />}
        </div>
      </div>
    </div>
  )
}

export default ProductDet
